import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { selectUser } from "../../../features/userSlice";
import { getCabinetQuotes } from "../../../views/CabinetQuotes/api";
import WidgetFrame, { WidgetEmpty, WidgetStat } from "./WidgetFrame";

// Status counts for the quotes this user can see, mirroring the stat row on
// the Cabinet Quote Dashboard.
const CabinetQuotesWidget = () => {
  const user = useSelector(selectUser);
  const [quotes, setQuotes] = useState(null);
  const [failed, setFailed] = useState(false);

  useEffect(() => {
    if (!user?.userID) return;
    getCabinetQuotes({ userId: user.userID })
      .then((list) => setQuotes(Array.isArray(list) ? list : []))
      .catch(() => setFailed(true));
  }, [user?.userID]);

  const count = (status) =>
    quotes.filter((quote) => quote.status === status).length;

  return (
    <WidgetFrame title="Cabinet Quotes" to="/cabinet-quotes">
      {quotes ? (
        <div className="grid grid-cols-3 gap-2">
          <WidgetStat value={count("draft")} label="Drafts" />
          <WidgetStat value={count("pending_customer")} label="With customer" />
          <WidgetStat value={count("approved")} label="Approved" />
        </div>
      ) : (
        <WidgetEmpty>
          {failed ? "Couldn't load cabinet quotes." : "Loading cabinet quotes…"}
        </WidgetEmpty>
      )}
    </WidgetFrame>
  );
};

export default CabinetQuotesWidget;
